import { Logger } from '@module-federation/sdk';

var logger = new Logger('[Module Federation Data Prefetch]');

export { logger as l };
